import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";
import Tas from "../assets/images/Contact/Tas.png";
import Telfon from "../assets/images/Contact/Telfon.png";
import WA from "../assets/images/Contact/WA.png";

// Importing Section
const Navbar = React.lazy(() => import("../component/Navbar/NavBar"));
const Footer = React.lazy(() => import("../component/Footer/Footer"));
const ScrollToTop = React.lazy(() => import('../component/ScrollToTop'));

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navItems: [
        { id: 1, idnm: "/", navheading: "Beranda", active: false, box: false },
        {
          id: 2,
          idnm: "fitur",
          navheading: "Fitur",
          active: false,
          box: false,
        },
        // {
        //   id: 3,
        //   idnm: "artikel",
        //   navheading: "Artikel",
        //   active: false,
        //   box: false,
        // },
        {
          id: 4,
          idnm: "kontak",
          navheading: "Kontak",
          active: true,
          box: false,
        },
        // {
        //   id: 5,
        //   idnm: 'privacy',
        //   navheading: 'Layanan',
        //   active: false,
        //   box: false,
        // },
        {
          id: 6,
          idnm: "register",
          navheading: "Register",
          active: false,
          box: true,
        },
        {
          id: 7,
          idnm: "register-partner",
          navheading: "Register Partner",
          active: false,
          box: true,
        },
        // { id: 1, idnm: "home", navheading: "Home" },
        // { id: 2, idnm: "about", navheading: "About Us" },
        // { id: 3, idnm: "services", navheading: "Services" },
        // { id: 4, idnm: "features", navheading: "Features" },
        // { id: 5, idnm: "project", navheading: "Project" },
        // { id: 6, idnm: "clients", navheading: "Clients" },
        // { id: 7, idnm: "contact", navheading: "Contact Us" },
      ],
      pos: document.documentElement.scrollTop,
      imglight: false,
      navClass: "",
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.scrollNavigation, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > this.state.pos) {
      this.setState({ navClass: "nav-sticky", imglight: false });
    } else {
      this.setState({ navClass: "", imglight: false });
    }
  };

  //set preloader div
  PreLoader = () => {
    return (
      <div id="preloader">
        <div id="status">
          <div className="spinner">
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { payload } = this.props;
    const profile = payload?.profile || {};
    
    // Clean phone number for WhatsApp link
    let waPhone = profile.noHp || "";
    if (waPhone.startsWith("0")) {
      waPhone = "62" + waPhone.substring(1);
    }
    const waLink = `https://wa.me/${waPhone}`;

    return (
      <React.Fragment>
        <Suspense fallback={this.PreLoader()}>
          {/* Importing Navbar */}
          <Navbar
            navItems={this.state.navItems}
            navClass={this.state.navClass}
            imglight={this.state.imglight}
          />

          <section className="contact-hero">
            <div className="blob-1"></div>
            <Container>
              <h1 className="hero-title" data-aos="fade-up" data-aos-duration="1000">
                Hubungi <span>Kami</span>
              </h1>
              <p className="hero-subtitle" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                Apakah Anda memiliki pertanyaan atau ingin berkolaborasi? Jangan ragu untuk menghubungi tim kami melalui kontak di bawah ini.
              </p>
            </Container>
          </section>

          <section className="contact-overlap-section" id="contact">
            <div className="contact-bg-shape"></div>
            <Container>
              <div 
                className="contact-card-container"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <div className="contact-item">
                  <div className="contact-icon-wrapper">
                    <img src={Tas} alt="Office" />
                  </div>
                  <h3>Kantor Pusat</h3>
                  <p>{profile.alamat || "Alamat belum diatur"}</p>
                </div>

                <div className="contact-divider"></div>

                <div className="contact-item">
                  <div className="contact-icon-wrapper">
                    <img src={Telfon} alt="Phone" />
                  </div>
                  <h3>Kontak Langsung</h3>
                  <p>
                    {profile.noHp} <br />
                    <a href={`mailto:${profile.email}`}>{profile.email}</a>
                  </p>
                </div>

                <div className="contact-cta-wrapper">
                  <button
                    className="wa-btn-premium"
                    onClick={() => window.open(waLink, "_blank")}
                  >
                    <img src={WA} alt="WhatsApp" />
                    Mulai Percakapan
                  </button>
                </div>
              </div>
            </Container>
          </section>

          {/* Importing Footer */}
          <Footer />
          <ScrollToTop />
        </Suspense>
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ mergeCms }) => ({
  payload: mergeCms.payload,
});

export default connect(mapStateToProps)(Contact);
